import React, { useState } from 'react';
import {
  FormControl,
  FormLabel,
  HStack,
  Image,
  InputGroup,
  PinInput,
  PinInputField,
  useToast,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { Flex, Text } from '@chakra-ui/layout';
import jwt_decode from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import { Button, ColorfulBar } from '~/components';
import { useAuth } from '~/hooks';
import { STORAGE } from '~/constants';
import logo from '~/assets/logo-service-gray.png';
import { PrivacyPolicyFooter } from '~/components/PrivacyPolicyFooter';

interface tokenInfo {
  usr: string;
}
export const VerifyCode: React.VFC = () => {
  const toast = useToast();
  const { formState } = useForm({});
  const { errors } = formState;
  const [isLoading, setIsLoading] = useState(false);
  const [codigo, setCodigo] = useState<string>('');
  const { verifyCode, resendEmail, clearSessionStorage } = useAuth();
  const tokenOtp = sessionStorage.getItem(`${STORAGE}:otpToken`) || '';
  const history = useHistory();

  function hideEmail() {
    const token: tokenInfo = jwt_decode(tokenOtp);
    const { usr } = token;
    if (!usr) {
      return '';
    }
    const atIndex = usr.indexOf('@');
    if (atIndex >= 4) {
      const hiddenName = '*'.repeat(atIndex - 4) + usr.slice(atIndex - 4);
      return `${hiddenName}`;
    }
    return usr;
  }
  const handleCodigoChange = (value: any) => {
    setCodigo(value);
  };

  async function handleVerifyCode() {
    try {
      await verifyCode({ code_token: tokenOtp, code: codigo });
    } catch (error: any) {
      if (error.response.status === 403) {
        toast({
          title: 'Erro ao verificar código.',
          description: 'Código expirado.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        return;
      }
      if (error.response.status === 401) {
        toast({
          title: 'Erro ao verificar código.',
          description: 'Código inválido.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      } else {
        console.log('ERRO');
        console.error(error);
        toast({
          title: 'Erro ao verificar código.',
          description:
            'Verifique se as credenciais estão corretas e tente novamente.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      }
    }
  }

  async function handleSendEmail() {
    try {
      await resendEmail();
    } catch (error: any) {
      if (error.response.status === 200) {
        toast({
          title: 'E-mail reenviado com sucesso.',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        setIsLoading(false);
      } else {
        console.log('ERRO');
        console.error(error);
        toast({
          title: 'Erro ao reenviar e-mail.',
          description: 'Tente novamente.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      }
    }
  }
  function goToLogin() {
    clearSessionStorage();
    history.push('/login');
  }

  return (
    <Flex w="100vw" h="100vh" flexDir="column">
      <ColorfulBar />
      <Flex justify="center" p="2" pt="20vh" h="100%">
        <Flex flexDir="column" align="center">
          <Flex flexDir="column" align="center" maxW={300}>
            <Image
              src={logo}
              maxW="200px"
              mb="8"
              cursor="pointer"
              onClick={() => goToLogin()}
            />
            <Text color="gray.400" textAlign="center" mb="8">
              {`Informe o código de verificação enviado para o email ${hideEmail()}`}
            </Text>
            <FormControl isInvalid={errors.codigo}>
              <FormLabel
                htmlFor="writeUpFile"
                style={{ fontSize: '14px' }}
                justifyContent="center"
                display="flex"
                marginBottom="8px"
                me={0}
              >
                Código de Verificação
              </FormLabel>
              <InputGroup justifyContent="space-evenly" padding="0 2.5rem">
                <HStack>
                  <PinInput
                    size="md"
                    onChange={event => handleCodigoChange(event)}
                  >
                    <PinInputField />
                    <PinInputField />
                    <PinInputField />
                    <PinInputField />
                  </PinInput>
                </HStack>
              </InputGroup>
            </FormControl>
            <Button
              type="submit"
              isLoading={isLoading}
              isDisabled={codigo.length < 4}
              justifyContent="center"
              mt={5}
              width="100%"
              onClick={() => handleVerifyCode()}
            >
              Verificar
            </Button>
            <Button
              type="submit"
              isLoading={isLoading}
              justifyContent="center"
              mt={5}
              width="100%"
              onClick={() => handleSendEmail()}
              variant="secondary"
            >
              Reenviar e-mail
            </Button>
          </Flex>
          <PrivacyPolicyFooter isPortal={false} />
        </Flex>
      </Flex>
    </Flex>
  );
};
